export const PAYMENT_METHOD = {
	CARD: 'card',
	BANK_TRANSFER: 'bank_transfer',
} as const;

export type PaymentMethod =
	(typeof PAYMENT_METHOD)[keyof typeof PAYMENT_METHOD];
